import React, { useState, useEffect } from 'react';
import useFetch from '../../../../components/hooks/useFetch';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { formNovoPermissionario } from './FormSchema';
import { yupResolver } from '@hookform/resolvers/yup';
import Textarea from '../../../../components/form/Textarea';
import { PESQUISA_LISTA_USUARIOS } from '../../../../services/delegacaoAcesso';

function FormNovoPermissionario({
  acaoCancelar,
  acaoFechar,
  dados,
  dadosEmpresa,
  dadosPerfil,
}) {
  const navigate = useNavigate();
  const methods = useForm({ resolver: yupResolver(formNovoPermissionario) });
  const [cpfs, setCpfs] = useState();
  const [listaCpfs, setListaCpfs] = useState();
  const [destino, setDestino] = useState();
  const { request: requestUsuarios, data: dadosUsuarios } = useFetch();

  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const listaCpfs = cpfs.split(';');
    setListaCpfs(listaCpfs);
  };

  useEffect(() => {
    if (listaCpfs && listaCpfs.length > 0) {
      requestUsuarios(
        PESQUISA_LISTA_USUARIOS(dadosEmpresa.idCorreios, listaCpfs),
      );
    }
  }, [listaCpfs]);

  useEffect(() => {
    if (dadosUsuarios) {
      chamaInclusao();
    }
  }, [dadosUsuarios]);

  const handleChange = (event) => {
    const { value } = event.target;
    setCpfs(value);
  };

  const chamaInclusao = () => {
    navigate('/delegacaoInclusao', {
      state: { dados, dadosEmpresa, dadosUsuarios, dadosPerfil },
    });
  };

  return (
    <>
      <form id="formNovoPermissionario" onSubmit={handleSubmit}>
        <div className="dialog-main">
          <div className="area-txt">
            <label htmlFor="cpfs" className="subtitulo-p">
              <p>
                Você pode adicionar um usuário informando um cpf/usuário, ou
                vários informando os cpf/usuários separados por ";". Ao informar
                o CPF, insira apenas os números.
              </p>
            </label>

            <Textarea
              id="cpfs"
              name="cpfs"
              rows="3"
              required
              value={cpfs}
              onChange={handleChange}
              {...formMethods}
            />

            <div className="legenda"></div>
          </div>
        </div>

        <br />

        <div className="dialog-footer">
          <button className="btn-txt btn-fecha-dialog" onClick={cancelar}>
            Cancelar
          </button>

          <button
            className="btn-cont btn-com-icone"
            type="submit"
            id="submtiContrato"
          >
            <i className="ic-contrato"></i>
            Cadastrar
          </button>
        </div>
      </form>
    </>
  );
}
export default FormNovoPermissionario;
